/* Pro-Witgoed — Levertijd renderer (multi-location aware)
 *
 * Leest data-attributes op .pw-levertijd-wrapper en bepaalt de juiste tekst:
 *   data-stock-denbosch  = voorraad op Den Bosch (uit variant metafield)
 *   data-stock-nod       = voorraad op NOD (uit variant metafield)
 *   data-handling-override = optionele leadtime-override per variant
 *   data-available       = is variant active in Shopify (back-compat)
 *
 * Flows (priority):
 *   1. Den Bosch > 0  → pickup/leverdag-model, identiek aan de PDP (pws-delivery-countdown.js):
 *                       vóór cutoff op een pickup-dag (ma-vr, geen feestdag) → levering =
 *                       eerstvolgende leverdag (meestal "Morgen in huis"); anders → pickup =
 *                       volgende pickup-dag, levering = eerstvolgende leverdag daarna.
 *   2. NOD > 0        → "Uiterlijk vrijdag X bezorgd" (handling-override of default 8 werkdagen)
 *   3. Available zonder voorraad → backorder NOD-flow
 *   4. Niet available → "Tijdelijk uitverkocht"
 *
 * Back-compat: oude wrappers met alleen data-stock blijven werken (data-stock="true"
 * wordt geïnterpreteerd als Den Bosch voorraad).
 */
(function () {
  if (typeof window.pwDeliveryScriptLoaded !== 'undefined') {
    if (typeof window.pwCalculateDeliveryDates === 'function') {
      window.pwCalculateDeliveryDates();
    }
    return;
  }
  window.pwDeliveryScriptLoaded = true;
  window.pwCountdownInterval = null;

  // Config — wordt door theme.liquid uit shop-metafields gerendered in window.pwsConfig.
  // Wijzigen in beheer → Voorraad-sync → Shopify → NOD-location → leadtime werkt direct door.
  var CFG = (typeof window !== 'undefined' && window.pwsConfig) || {};
  var CUTOFF_HOUR = typeof CFG.cutoffHour === 'number' ? CFG.cutoffHour : 17;
  var CUTOFF_MINUTE = typeof CFG.cutoffMinute === 'number' ? CFG.cutoffMinute : 0;
  var NOD_DEFAULT_LEAD_DAYS = typeof CFG.backorderDays === 'number' ? CFG.backorderDays : 8;
  var HOLIDAYS = [
    // 2026
    '2026-01-01', '2026-04-03', '2026-04-05', '2026-04-06', '2026-04-27',
    '2026-05-05', '2026-05-14', '2026-05-24', '2026-05-25',
    '2026-12-25', '2026-12-26',
    // 2027
    '2027-01-01', '2027-03-26', '2027-03-28', '2027-03-29', '2027-04-27',
    '2027-05-06', '2027-05-16', '2027-05-17',
    '2027-12-25', '2027-12-26'
  ];

  function clearCountdown() {
    if (window.pwCountdownInterval) {
      clearInterval(window.pwCountdownInterval);
      window.pwCountdownInterval = null;
    }
  }

  function startCountdown() {
    clearCountdown();
    function tick() {
      var nowNL = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
      var cutoff = new Date(nowNL);
      cutoff.setHours(CUTOFF_HOUR, CUTOFF_MINUTE, 0, 0);
      var diff = cutoff - nowNL;
      document.querySelectorAll('.pw-levertijd-countdown').forEach(function (span) {
        if (diff > 0 && span.dataset.active === 'true') {
          var h = String(Math.floor(diff / 3600000)).padStart(2, '0');
          var m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
          var s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
          span.textContent = 'bestel binnen ' + h + ':' + m + ':' + s;
          span.style.display = 'inline';
        } else {
          span.style.display = 'none';
          span.dataset.active = 'false';
          if (diff <= 0) clearCountdown();
        }
      });
    }
    tick();
    window.pwCountdownInterval = setInterval(tick, 1000);
  }

  function fmtDateKey(d) {
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + dd;
  }

  // Leverdag: ma t/m za, geen zondag, geen NL-feestdag.
  // (Zaterdag = leverdag bij PW; alleen pakketdienst-pickup zou wel ma-vr zijn,
  //  maar voor leadtime-rekening tellen we leverdagen.)
  function isWorkDay(d) {
    var day = d.getDay();
    if (day === 0) return false;
    return HOLIDAYS.indexOf(fmtDateKey(d)) === -1;
  }

  // Pickup-dag: ma t/m vr, geen feestdag — de dagen dat een bestelling op pad
  // gaat. Zelfde definitie als isPickupDay in pws-delivery-countdown.js (PDP).
  function isPickupDay(d) {
    var day = d.getDay();
    if (day === 0 || day === 6) return false;
    return HOLIDAYS.indexOf(fmtDateKey(d)) === -1;
  }

  // Eerstvolgende dag ná start waarvoor pred true is.
  function nextDayWhere(start, pred) {
    var d = new Date(start);
    d.setDate(d.getDate() + 1);
    while (!pred(d)) d.setDate(d.getDate() + 1);
    return d;
  }

  function addWorkDays(start, n) {
    var d = new Date(start);
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (isWorkDay(d)) added++;
    }
    return d;
  }

  var dayNames = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];

  function fmtNL(date) {
    return date.toLocaleDateString('nl-NL', { day: 'numeric', month: 'long' });
  }

  function calculate() {
    var nowNL = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
    var hasActiveCountdown = false;

    document.querySelectorAll('.pw-levertijd-wrapper:not(.processed)').forEach(function (el) {
      var stockDB = parseInt(el.getAttribute('data-stock-denbosch') || '0', 10);
      var stockNOD = parseInt(el.getAttribute('data-stock-nod') || '0', 10);
      var handlingOverride = parseInt(el.getAttribute('data-handling-override') || '0', 10);
      var isAvailable = el.getAttribute('data-available') === 'true';
      var textEl = el.querySelector('.pw-levertijd-tekst');
      var countdownEl = el.querySelector('.pw-levertijd-countdown');

      if (!textEl) {
        el.classList.add('processed');
        return;
      }

      // Back-compat: oude wrappers met alleen data-stock="true|false"
      if (!el.hasAttribute('data-stock-denbosch') && el.hasAttribute('data-stock')) {
        var legacyHasStock = el.getAttribute('data-stock') === 'true';
        if (legacyHasStock) {
          stockDB = 1;
        } else if (isAvailable) {
          stockNOD = 1;
        }
      }

      // Flow-decision
      if (!isAvailable && stockDB === 0 && stockNOD === 0) {
        textEl.innerText = 'Tijdelijk uitverkocht';
        el.style.color = '#d32f2f';
      } else if (stockDB > 0) {
        // Den Bosch flow — zelfde pickup/leverdag-model als de PDP
        // (pws-delivery-countdown.js), zodat kaart en productpagina altijd
        // dezelfde bezorgdatum tonen.
        el.style.color = '#2e7d32';
        var cutoff = new Date(nowNL);
        cutoff.setHours(CUTOFF_HOUR, CUTOFF_MINUTE, 0, 0);
        var beforeCutoff = isPickupDay(nowNL) && nowNL < cutoff;
        var dlv;
        if (beforeCutoff) {
          dlv = nextDayWhere(nowNL, isWorkDay);
        } else {
          // Cutoff gemist of geen pickup-dag (za/zo/feestdag): pakket gaat
          // mee op de volgende pickup-dag, bezorgd op de leverdag daarna.
          var pickup = nextDayWhere(nowNL, isPickupDay);
          dlv = nextDayWhere(pickup, isWorkDay);
        }
        var todayMid = new Date(nowNL.getFullYear(), nowNL.getMonth(), nowNL.getDate());
        var dlvMid = new Date(dlv.getFullYear(), dlv.getMonth(), dlv.getDate());
        var isTomorrow = Math.round((dlvMid - todayMid) / 86400000) === 1;
        if (beforeCutoff && isTomorrow) {
          textEl.innerText = 'Morgen in huis';
          if (countdownEl) {
            countdownEl.dataset.active = 'true';
            hasActiveCountdown = true;
          }
        } else {
          textEl.innerText = dayNames[dlv.getDay()] + ' ' + fmtNL(dlv) + ' bezorgd';
          if (countdownEl) countdownEl.style.display = 'none';
        }
      } else if (stockNOD > 0 || isAvailable) {
        // NOD / backorder flow: handling-override of default leadtime
        el.style.color = '#2e7d32';
        var leadDays = handlingOverride > 0 ? handlingOverride : NOD_DEFAULT_LEAD_DAYS;
        var dlv2 = addWorkDays(nowNL, leadDays);
        textEl.innerText = 'Uiterlijk ' + dayNames[dlv2.getDay()].toLowerCase() + ' ' + fmtNL(dlv2) + ' bezorgd';
        if (countdownEl) countdownEl.style.display = 'none';
      } else {
        textEl.innerText = 'Tijdelijk uitverkocht';
        el.style.color = '#d32f2f';
      }

      el.classList.add('processed');
    });

    if (hasActiveCountdown) startCountdown();
  }

  window.pwCalculateDeliveryDates = calculate;

  document.addEventListener('DOMContentLoaded', calculate);
  document.addEventListener('shopify:section:load', function () {
    clearCountdown();
    document.querySelectorAll('.pw-levertijd-wrapper.processed').forEach(function (el) {
      el.classList.remove('processed');
    });
    calculate();
  });
  calculate();
})();
